module.exports = __webpack_public_path__ + "static/media/CoinNoText.24e39e00.svg";